import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { projects } from '../data/projects';

const Portfolio = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top when Portfolio page loads
    window.scrollTo(0, 0);
  }, []);

  const handleProjectClick = (projectId) => {
    navigate(`/project/${projectId}`);
    window.scrollTo(0, 0);
  };

  return (
    <div className="pt-32">
      {/* Hero */}
      <div className="bg-slate-900 py-20 text-center text-white mb-12 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-green-700/20 rounded-full mix-blend-screen filter blur-3xl"></div>
        <div className="relative z-10 px-4">
          <h1 className="text-4xl md:text-6xl font-bold font-serif mb-4">Our Portfolio</h1>
          <p className="text-slate-300 max-w-2xl mx-auto text-lg">
            A showcase of Swedish engineering excellence, delivering high-impact solutions for global market leaders.
          </p>
        </div>
      </div>

      {/* Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 cursor-pointer"
              onClick={() => handleProjectClick(project.id)}
            >
              <div className="h-64 overflow-hidden relative">
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 z-10 transition-colors duration-300"></div>
                <img
                  src={project.image}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  alt={project.title}
                />
                <div className="absolute top-4 right-4 z-20 bg-white/90 backdrop-blur text-xs font-bold px-3 py-1 rounded-full text-slate-900 shadow-sm">
                  {project.category}
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-green-700 transition-colors">
                  {project.title}
                </h3>
                <p className="text-slate-600 mb-6 line-clamp-2">{project.shortDesc}</p>
                <span className="text-green-700 font-semibold text-sm uppercase tracking-wide flex items-center gap-2">
                  View Case Study <i className="fas fa-arrow-right transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
